module.exports = __webpack_public_path__ + "static/images/facebook.d0915224d733bbd947195472fe454921.jpg";